import type { StaticImageData } from 'next/image'
import Image from 'next/image'

import { altMap, colorMap } from '@/global/components/Logo/Logo.constants'

type Color = 'on-dark' | 'on-light'

type LogoSize = 'small' | 'medium'

interface LogoProps {
  color?: Color
  size?: LogoSize
}

/*
 * O arquivo tem 200x104. As duas caixas mantem essa proporcao para a imagem nao
 * achatar: 44/23 e 50/26 batem com 200/104.
 *
 * `small` tem os 44px de largura da marca no header de producao, onde o SVG
 * mede 44x23.7 dentro de uma caixa de 56x40.
 */
const sizeMap: Record<LogoSize, string> = {
  small: 'h-[23px] w-[44px]',
  medium: 'h-[26px] w-[50px]'
}

const computedLogo = (color: Color): string | StaticImageData => {
  const existsColor = colorMap.has(color)

  return (existsColor ? colorMap.get(color) : colorMap.get('on-light')) as
    | string
    | StaticImageData
}

const computedAlt = (color: Color): string => {
  const existsAlt = altMap.has(color)

  return (existsAlt ? altMap.get(color) : altMap.get('on-light')) as string
}

const Logo = ({ color = 'on-light', size = 'medium' }: LogoProps) => {
  return (
    <Image
      className={sizeMap[size]}
      width={50}
      height={26}
      alt={computedAlt(color)}
      src={computedLogo(color)}
    />
  )
}

export { Logo }
export type { Color, LogoProps }
